module.exports = __webpack_public_path__ + "img/form-cta-bg.a79ca715.webp";